import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class processService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };
  getLimitData = (params) => {
    return AxiosService.Get(`api/cam/srm/parameters-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  getAuditList = (params) => {
    return AxiosService.Get(`api/cam/srm/limit/data/audit/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  getLimitDropdown = (params) => {
    return AxiosService.Get(`api/cam/srm/limits-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  getParameterSpecificationList = (params) => {
    return AxiosService.Get(`api/cam/srm/parameter-specification-list/`, {
      ...this.getHeaders(),
      params: params,
    });
  };

  submitFormData = (data, obj) => {
    return AxiosService.Post(`api/cam/srm/create-limits/`, obj, {
      params: data,
      ...this.getHeaders(),
    });
  };

  exportPDF = (obj) => {
    return AxiosService.Post(`api/export-pdf`, obj, {
      ...this.getHeaders(),
    });
  };

  exportXL = (obj) => {
    return AxiosService.Post(`api/xl`, obj, {
      ...this.getHeaders(),
    });
  };

  importXL = (obj) => {
    return AxiosService.Post(`api/import`, obj, {
      ...this.getHeaders(),
    });
  };

  deleteLimit = (obj) => {
    return AxiosService.Delete(`api/cam/srm/delete-limit/`, obj);
  };

  updateLimit = (params, obj) => {
    return AxiosService.Put(
      `api/cam/srm/update-limit/`,
      obj,
      params,
      true,
      this.getHeaders()
    );
  };
}
